/* eslint-disable */
import { getDictDataOptionsList } from '@/api/dictdata'
// 已知子节点 求所有父节点
export const findPatentValue = (array, value, valueName = 'id', childrenName = 'children') => {
    if (!value || !Array.isArray(array)) return []
    const result = []
    let valid = false
    const seek = (array, value) => {
        let parentValue = ''
        const up = (array, value, lastValue) => {
            array.forEach((v) => {
                const val = v[valueName]
                const child = v[childrenName]
                if (val === value) {
                    valid = true
                    parentValue = lastValue
                    return
                }
                if (child && child.length) up(child, value, val)
            })
        }
        up(array, value)
        if (parentValue) {
            result.unshift(parentValue)
            seek(array, parentValue)
        }
    }
    seek(array, value)
    return valid ? [...result, value] : []
}

export const dateFormat = (fmt, date) => {
    let ret = ''
    const opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString()
    }
    for (const k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
            fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
        }
    }
    return fmt
}

export const deepCopy = (source) => {
    if (!isObject(source)) return source
    const target = Array.isArray(source) ? [] : {}
    for (const k in source) {
        if (Object.prototype.hasOwnProperty.call(source, k)) {
            if (typeof source[k] === 'object') {
                target[k] = deepCopy(source[k])
            } else {
                target[k] = source[k]
            }
        }
    }
    return target
}
function isObject(obj) {
    return typeof obj === 'object' && obj !== null
}

/**
 *
 * @param {*} data 数组/二维数组
 * @param {*} type min 最小值 max 最大值
 * @param {*} params 需要比较的字段
 * @returns min or max
 * @description 求最值大最小值
 */
export const getMinOrMax = (data, type, params = 'value') => {
    if (data && data.length === 0) return
    const list = data && data.length ? data.flat() : []
    const allNum = []
    list &&
        list.forEach((item) => {
            item && allNum.push(item[params])
        })
    if (allNum.length) {
        if (type === 'min') {
            if (allNum.find((ele) => ele.toString().indexOf('e') > -1)) {
                // return Math.min(...allNum)
                const minVal = Math.min(...allNum)
                return minVal
            } else {
                return Math.min(...allNum)
            }
        }
        if (type === 'max') {
            if (allNum.find((ele) => ele.toString().indexOf('e') > -1)) {
                return Math.max(...allNum)
            } else {
                return Math.max(...allNum)
            }
        }
    }
}

/**
 * @param {*} src 原始数据
 * @param {*} pos 精度
 * @returns 精度
 */
export const fomatFloat = (src, pos) => {
    if (src === undefined) return
    if (src.toString().indexOf('e') > -1) {
        return src
    }
    return (Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos)).toFixed(pos) || '-'
}

// 是否转换为科学技术法显示
export const toNonExponential = (num) => {
    if (num) {
        var m = Number(num)
            .toExponential()
            .match(/\d(?:\.(\d*))?e([+-]\d+)/)
        // console.log(m)
        if (m?.[1]?.length > 6) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
    // return num.toFixed(Math.max(0, (m[1] || '').length - m[2]))
}

export const transferKbtoMb = (a, b) => {
    if (a === 0) return '0 B'
    var c = 1024
    var d = b || 2
    var e = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    var f = Math.floor(Math.log(a) / Math.log(c))
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}

// 获取当前utc时间戳
export const getUTCTime = () => {
    const d1 = new Date()
    const d2 = new Date(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds())
    return Date.parse(d2)
}

// ws数据默认六位精度不补零
export const transferWsData = (value) => {
    if (value !== 'undefined') {
        var m = Number(value)
            .toExponential()
            .match(/\d(?:\.(\d*))?e([+-]\d+)/)
        if (m?.[1]?.length > 6 || (m?.[2] < 0 && m[2] > -6)) {
            return Number(value).toFixed(6)
        } else {
            return value + ''
        }
    } else {
        return ''
    }
}

// 获取字典数据类型下拉框选项
export const getDictDataSelect = (data, type = 'array') => {
    if (type === 'array') {
        if (!data) {
            return []
        }
        return data.map((v) => ({
            value: v.value,
            label: v.label
        }))
    }
    if (type === 'object') {
        if (!data) return {}
        const obj = {}
        data.forEach((item) => {
            obj[item.value] = item.label
        })
        return obj
    }
}
// 获取字典数据类型下拉框选项
export const getDataCodeOptions = async (code) => {
    const list = await getDictDataOptionsList(code)
    const obj = {}
    list.forEach((ele) => {
        obj[ele.value] = ele
    })
    return { list, jsonData: obj }
}

/**
 * 时间减少
 * @param {*} now 时间 yyyy-MM-dd HH:mm:ss
 * @param {*} minute 减少时间
 * @returns
 */
export function timeFormatReducet(now, minute) {
    //60000毫秒 代表1分钟
    let state = new Date(new Date(now).getTime() - minute * 60000),
        date = new Date(state),
        minutes = date.getMinutes(),
        seconds = date.getSeconds()

    date < 0 ? (date = `0${date}`) : (date = date)
    minutes < 0 ? (minutes = `0${minutes}`) : (minutes = minutes)
    minutes < 10 ? (minutes = `0${minutes}`) : (minutes = minutes)
    seconds < 0 ? (seconds = `0${seconds}`) : (seconds = seconds)
    seconds < 10 ? (seconds = `0${seconds}`) : (seconds = seconds)

    let mounth = date.getMonth() + 1
    mounth + 1 < 10 ? (mounth = `0${mounth}`) : (mounth = mounth)

    //转换格式
    return `${date.getFullYear()}-${mounth}-${date.getDate()} ${date.getHours()}:${minutes}:${seconds}`
}

/**
 * 时间增加
 * @param {*} now  时间 yyyy-MM-dd HH:mm:ss
 * @param {*} minute 增加时间
 * @returns
 */
export function timeFormatPlus(now, minute) {
    //60000毫秒 代表1分钟
    let state = new Date(new Date(now).getTime() + minute * 60000),
        date = new Date(state),
        minutes = date.getMinutes(),
        seconds = date.getSeconds()
    date < 0 ? (date = `0${date}`) : (date = date)
    minutes < 0 ? (minutes = `0${minutes}`) : (minutes = minutes)
    minutes < 10 ? (minutes = `0${minutes}`) : (minutes = minutes)
    seconds < 0 ? (seconds = `0${seconds}`) : (seconds = seconds)
    seconds < 10 ? (seconds = `0${seconds}`) : (seconds = seconds)

    let mounth = date.getMonth() + 1
    mounth + 1 < 10 ? (mounth = `0${mounth}`) : (mounth = mounth)

    //转换格式
    return `${date.getFullYear()}-${mounth}-${date.getDate()} ${date.getHours()}:${minutes}:${seconds}`
}

const dateFormatDay = (dateData) => {
    var date = new Date(dateData)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    const time = y + '-' + m + '-' + d
    return time
}

// 获取当年
export function getCurrentYear(newDate) {
    var year = newDate.getFullYear() // 获取年份
    var startOfYearTimestamp = new Date(year, 0).valueOf() // 设置为该年第一天（月份从0开始计算）
    var endOfYearTimestamp = new Date(year + 1, 0).valueOf() - 1 // 设置为该年最后一天的前一天
    return [dateFormatDay(startOfYearTimestamp), dateFormatDay(endOfYearTimestamp)]
}

// 获取当月
export function getCurrentMonth(newDate) {
    newDate.setDate(1)
    // 设置为本月第一天（0表示星期日）
    newDate.setMonth(newDate.getMonth(), 1) // 注意这里不能直接写成date.setMonth(date.getMonth() + 1)，因为如果今天就是最后一天，那么会导致下个月的第一天被计算在内

    // 获取本月第一天的时间戳
    var startTimeStamp = Math.floor(new Date(newDate).valueOf())

    // 将日期加上一个月并再次转换为时间戳
    newDate.setMonth(newDate.getMonth() + 1, 0) // 注意这里要先加两个月才能得到正确的结束日期，然后再设置为本月最后一天
    var endTimeStamp = Math.ceil(new Date(newDate).valueOf())
    console.log(startTimeStamp, endTimeStamp)
    return [dateFormatDay(startTimeStamp), dateFormatDay(endTimeStamp)]
}

// 获取当周
export function getCurrentWeek(newDate) {
    const year = newDate.getFullYear()
    const month = newDate.getMonth()
    const date = newDate.getDate() // 获取日期
    const day = newDate.getDay() // 获取周几，0-6，0表示周日
    const _day = day === 0 ? 7 : day
    const startDate = new Date(year, month, date - _day + 1)
    return [dateFormatDay(startDate), dateFormatDay(new Date(new Date(startDate).getTime() + 6 * 24 * 3600 * 1000))]
}

// 获取近12月
export function getInThePastTwelveMonths() {
    var result = [] // 先创建一个空数组，方便后面存储日期数据
    var d = new Date() // 当前时间
    var year = d.getFullYear() // 当前年份
    d.setMonth(d.getMonth() + 1, 1) // 设置月份,设置当前日为1号 （避免出现31号时候，其他月份没有31号的bug）
    for (var i = 0; i < 12; i++) {
        //开始循环
        d.setMonth(d.getMonth() - 1) // 月份值-1  循环的时候在当前月份上减一 来获取上个月的月份（0 ~ 11）
        var m = d.getMonth() + 1 // 月份 + 1 来获取真正的月份 （1 ~ 12）
        m = m < 10 ? '0' + m : m // 三元表达式来判断 如果小于10月 给前面 +0 如果大于等于10月 则不变输出
        result.push(d.getFullYear() + '-' + m) // 将 循环出来的 年月 一次 存放进 result 数组中
    }
    return result.reverse() // 返回反向排列数组
}

export function getPostFormData(data) {
    const postFormData = new FormData()
    for (const key in data) {
        postFormData.append(key, data[key])
    }
    return postFormData
}
